import { TmTableElementManagerError } from '@/core/error/table/tableManager/tmTableElementManagerError'

export class TmTableElementManagerFactoryInvalidError extends TmTableElementManagerError {
  public name = 'TmTableManagerFactoryInvalidError'
}
